import { FieldSet, Info, Layer, Panel } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { useTemplatesDetailsContext } from '../context'

export const Details = () => {
  const { data } = useTemplatesDetailsContext()
  const {
    name,
    type,
    level,
    internal,
    frequency,
    startDateType,
    dueStartDate,
    expirationDelayDays,
    showOptional,
    states,
    showBusinessTypes,
    showEntityTypes,
    showLicenseTypes,
    showLicenseSubtypes,
    showContactTypes,
    showMinimalOwnershipPercent
  } = data

  return (
    <Layer rounded shadowed stretch>
      <Panel rounded shadowed collapsible={false} title="Template Details" anchor="details">
        <div style={{ padding: '30px 35px' }}>
          <FieldSet legend="General">
            <FormRow>
              <Col>
                <Info label="Document name">{name}</Info>
              </Col>
              <Col>
                <Info label="Type">{type}</Info>
              </Col>
            </FormRow>
            <FormRow>
              <Col>
                <Info label="Level">{level}</Info>
              </Col>
              <Col>
                <Info label="Internal">{internal}</Info>
              </Col>
            </FormRow>
            <FormRow>
              <Col>
                <Info label="Frequency">{frequency}</Info>
              </Col>
              <Col>
                <Info label="Start date type">{startDateType}</Info>
              </Col>
            </FormRow>
            <FormRow>
              <Col>
                <Info label="Due start date">{dueStartDate}</Info>
              </Col>
              <Col>
                <Info label="Expiration delay days">{expirationDelayDays}</Info>
              </Col>
            </FormRow>
            <FormRow>
              <Col>
                <Info label="Package">{data.package}</Info>
              </Col>
              {showOptional && (
                <Col>
                  <Info label="Optional">{showOptional}</Info>
                </Col>
              )}
            </FormRow>
            <FormRow>
              <Col>
                <Info label="State(s)">{states}</Info>
              </Col>
            </FormRow>
          </FieldSet>
          {(showBusinessTypes || showEntityTypes) && (
            <FieldSet legend="Relationship">
              <FormRow>
                <Col>
                  <Info label="Business Type">{showBusinessTypes}</Info>
                </Col>
                <Col>
                  <Info label="Entity Type">{showEntityTypes}</Info>
                </Col>
              </FormRow>
            </FieldSet>
          )}
          {(showLicenseTypes || showLicenseSubtypes) && (
            <FieldSet legend="License">
              <FormRow>
                <Col>
                  <Info label="Type(s)">{showLicenseTypes}</Info>
                </Col>
                <Col>
                  <Info label="Subtype(s)">{showLicenseSubtypes}</Info>
                </Col>
              </FormRow>
            </FieldSet>
          )}
          {(showContactTypes || showMinimalOwnershipPercent) && (
            <FieldSet legend="Contact">
              <FormRow>
                <Col>
                  <Info label="Type(s)">{showContactTypes}</Info>
                </Col>
                <Col>
                  <Info label="Minimal ownership %">{showMinimalOwnershipPercent}</Info>
                </Col>
              </FormRow>
            </FieldSet>
          )}
        </div>
      </Panel>
    </Layer>
  )
}
